export default __webpack_public_path__ + "static/media/get-started-step-2.50606e76.png";